/**
 * MenuItemIconContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Props for the menu item icon container.
 */
interface Props {
  collapse: boolean;
}

/**
 * Styled container for the menu item icon.
 */
const MenuItemIconContainer = styled.div<Props>`
  // filter: drop-shadow(0 0 1.5px rgba(0, 0, 0, 0.8));
  margin-right: ${({ collapse }) =>
    collapse ? 0 : `${16 * Screen.widthRatio}px`};
`;

export default withOpacity(MenuItemIconContainer);
